import {
  Children,
  PropsWithChildren,
  ReactNode,
  cloneElement,
  isValidElement,
} from 'react';

import { DropdownChevron } from 'components/Dropdown/Chevron/DropdownChevron';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownMenu } from 'components/Dropdown/menus/Menu/DropdownMenu';
import { Icon } from 'components/Icon/Icon';
import { IconName } from 'components/Icon/IconName';
import { Pill } from 'components/Pill/Pill';
import { SearchJobsRefinementType } from 'modules/search/constants/refinements/searchJobsRefinementTypes';
import { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { spacing } from 'theme/theme';

import { SearchFacetDropdownHolder } from './SearchFacetDropdown.styled';
import { useSearchFacetDropdown } from './useSearchFacetDropdown';

type Props = {
  facetType: SearchJobsRefinementType;
} & {
  icon?: IconName;
  label: ReactNode;
};

export function SearchFacetDropdown({
  children,
  facetType,
  icon,
  label,
}: PropsWithChildren<Props>) {
  const { filterState, holderRef, toggleDropdown } =
    // @ts-expect-error need to figure out type refinement
    useSearchFacetDropdown(facetType);

  return (
    <SearchFacetDropdownHolder
      data-qa-id={`search-filter-dropdown-${facetType}`}
      ref={holderRef}
      data-facet-state={filterState}
    >
      <Dropdown
        onToggle={toggleDropdown}
        trigger={
          <Pill
            qaId="search-filter-dropdown-heading"
            size={{ xs: 'small', md: 'medium' }}
            prefix={icon ? <Icon size={18} name={icon} /> : undefined}
            suffix={<DropdownChevron size={16} />}
          >
            {label}
          </Pill>
        }
      >
        <DropdownMenu offsetY={spacing[8]} placement="bottom-left">
          <div data-facet-type={facetType}>
            {isValidElement<{ variant: SearchFacetVariant }>(children)
              ? Children.only(cloneElement(children, { variant: 'dropdown' }))
              : children}
          </div>
        </DropdownMenu>
      </Dropdown>
    </SearchFacetDropdownHolder>
  );
}
